import { Link } from "react-router-dom";
import { Ambience } from "@/components/ax/Ambience";
import { Mark, Wordmark } from "@/components/ax/Mark";
import { useI18n } from "@/i18n";

export const AuthCard = ({ title, flash, testId, children }) => {
  const { t } = useI18n();
  return (
    <div className="relative isolate min-h-screen bg-ax-bg px-4 py-8 text-ax-text md:flex md:items-center md:justify-center">
      <Ambience />
      <a href="#konten" className="skip-link" data-testid="skip-link">
        {t("skip")}
      </a>
      <div className="mx-auto w-full max-w-[400px]">
        <main
          id="konten"
          data-testid={testId}
          className="enter rounded-[12px] border border-ax-border bg-ax-surface p-6 shadow"
        >
          <Link to="/" aria-label="AXORIS" className="inline-flex items-center gap-3 text-ax-brand">
            <Mark size={24} />
            <Wordmark />
          </Link>
          <h1 className="type-h1 mt-8" data-testid="auth-title">
            {title}
          </h1>
          <p
            role="status"
            data-testid="auth-flash"
            className="m-0 mt-2 min-h-[20px] text-sm leading-5 text-ax-text-2"
          >
            {flash}
          </p>
          {children}
        </main>
        <p className="m-0 mt-6 text-center text-sm leading-5 text-ax-muted">
          <a href="mailto:halo@axoris.id" data-testid="support-email" className="text-ax-link hover:underline">
            halo@axoris.id
          </a>
        </p>
      </div>
    </div>
  );
};
